import { QuestionnaireAttachmentMeta } from "../hooks/attachment";

/**
 * Merges attachment metadata returned from the backend with metadata from a
 * newly completed upload. New uploads are removable in their open update cycle.
 */
export const mergeAttachmentMeta = (
  existingMeta?: QuestionnaireAttachmentMeta,
  pendingMeta?: {
    id: string;
    size: string;
    canDelete: boolean;
    confirmed_at?: string | null;
  },
  fallback?: { filename: string; s3Key: string },
): QuestionnaireAttachmentMeta | undefined => {
  if (!pendingMeta) return existingMeta;

  const base = existingMeta || fallback;
  if (!base) return undefined;

  return {
    id: existingMeta?.id ?? pendingMeta.id,
    ...base,
    size: pendingMeta.size,
    confirmed_at: pendingMeta.confirmed_at ?? existingMeta?.confirmed_at,
    canDelete: existingMeta?.canDelete ?? pendingMeta.canDelete,
  };
};
